export const _sharedActionsConstantsPlayer = {
  PUT_AUDIO_WAVE: "player/PUT_AUDIO_WAVE",
  SET_BROKEN_AUDIOS: "player/SET_BROKEN_AUDIOS",
  FETCH_WAVE_FORMS_DICTIONARY: "player/FETCH_WAVE_FORMS_DICTIONARY",
  SET_IS_SMALL_PLAYER_VISIBLE: "player/SET_IS_SMALL_PLAYER_VISIBLE",
};

export const _sharedActionsPlayer = {
  putAudioWaveformsData: (data) => ({
    type: _sharedActionsConstantsPlayer.PUT_AUDIO_WAVE,
    data,
  }),
  setBrokenAudios: (id) => ({
    type: _sharedActionsConstantsPlayer.SET_BROKEN_AUDIOS,
    data: id,
  }),
  fetchWaveformsDictionary: (url, chapterId) => ({
    type: _sharedActionsConstantsPlayer.FETCH_WAVE_FORMS_DICTIONARY,
    data: {url, chapterId},
  }),
  setIsSmallPlayerVisible: (flag) => ({
    type: _sharedActionsConstantsPlayer.SET_IS_SMALL_PLAYER_VISIBLE,
    data: flag,
  }),
};
